import { useSEO, SOCIAL_IMAGE } from '@/hooks/useSEO';
import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';
import ResourcesHero from './components/ResourcesHero';
import ResourcesGrid from './components/ResourcesGrid';

export default function ResourcesPage() {
  useSEO({
    title: 'CSCF Resources | Support for Families with Cardiospondylocarpofacial Syndrome',
    description:
      'Curated resources for CSCF families: early intervention, pediatric cardiology, hearing specialists, school support, orthopedics, and feeding therapy for Cardiospondylocarpofacial syndrome.',
    keywords:
      'CSCF resources, Cardiospondylocarpofacial syndrome support, CSCF early intervention, CSCF cardiology, CSCF hearing support, rare disease resources, CSCF families',
    canonical: `${import.meta.env.VITE_SITE_URL ?? 'https://cscfsupport.org'}/resources`,
    ogImage: SOCIAL_IMAGE,
    breadcrumbs: [
      { name: 'Home', url: `${import.meta.env.VITE_SITE_URL ?? 'https://cscfsupport.org'}/` },
      { name: 'Resources', url: `${import.meta.env.VITE_SITE_URL ?? 'https://cscfsupport.org'}/resources` },
    ],
    structuredData: [
      {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: 'CSCF Support & Resources for Families',
        url: `${import.meta.env.VITE_SITE_URL ?? 'https://cscfsupport.org'}/resources`,
        description:
          'Curated resources for families navigating a Cardiospondylocarpofacial syndrome (CSCF) diagnosis, including medical specialists, therapy, educational support, and genetic testing guidance.',
        isPartOf: { '@type': 'WebSite', name: 'CSCF Support', url: `${import.meta.env.VITE_SITE_URL ?? 'https://cscfsupport.org'}/` },
        about: {
          '@type': 'MedicalCondition',
          name: 'Cardiospondylocarpofacial Syndrome',
          alternateName: ['CSCF', 'CSCFS'],
        },
        mainEntity: {
          '@type': 'ItemList',
          name: 'CSCF Family Resources',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Genetic Testing Guide — Whole Exome Sequencing for CSCF' },
            { '@type': 'ListItem', position: 2, name: 'Pediatric Cardiology Resources' },
            { '@type': 'ListItem', position: 3, name: 'Early Intervention & Developmental Therapy' },
            { '@type': 'ListItem', position: 4, name: 'Hearing Loss & Audiology Support' },
            { '@type': 'ListItem', position: 5, name: 'School & Educational Support' },
            { '@type': 'ListItem', position: 6, name: 'Rare Disease Organizations & Advocacy' },
          ],
        },
      },
    ],
  });

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <ResourcesHero />
      <ResourcesGrid />
      <Footer />
    </div>
  );
}
